import List from "./List";
import Calendar from "mdi-material-ui/Calendar";

export const DailyReportList = List;
export const DailyReportIcon = Calendar;
